import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, NG_VALIDATORS } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CookieModule, CookieService } from '@ngx-toolkit/cookie';
import { AppComponent } from './app.component';
import { GeocoderResultDetailComponent } from './shared/geo/geocoder-result-detail.component';
import { OutlookChartComponent } from './resort-listing/outlook-chart.component';
import { SwiperModule, SwiperConfigInterface, SwiperScrollbarInterface, SwiperNavigationInterface, SwiperAutoplayInterface } from 'ngx-swiper-wrapper';
import { TruncateModule } from 'ng2-truncate';
import { MainHeaderComponent } from './header/main-header.component';
import { MainFooterComponent } from './footer/main-footer.component';
import { SearchCalendarComponent } from './resort-listing/search-calendar.component';
import { ResortListingPreferredComponent } from './resort-listing/resort-listing-preferred/resort-listing-preferred.component';
import { ResortListingCarouselComponent } from './resort-listing/resort-listing-carousel/resort-listing-carousel.component';
import { ResortListingComponent } from './resort-listing/resort-listing.component';
import { ResortApplication, ResortApplicationBase } from './services/resort-application.service';
import { Core, UrlServiceBase, QueryParamService, DisplayServiceBase, DisplayService, UrlService, ErrorHandler, DefaultErrorHandler, Queryable, JoinPipe, OvsCurrencyPipe, CreditCardValidator, ValidationServicesBase, ValidationServices } from './shared/core/ovs.core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
//animations
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ParallaxMousemoveModule } from 'ngx-parallax-mousemove';

import { NouisliderModule } from 'ng2-nouislider';
import { ResortListingStandardComponent } from './resort-listing/resort-listing-standard/resort-listing-standard.component';
import { ResortDetailComponent } from './resort-detail/resort-detail.component';
import { ResortHeroGalleryComponent } from './resort-detail/resort-hero-gallery/resort-hero-gallery.component';
import { ApplicationConfigurationClientBase, ApplicationConfigurationClient } from './services/application-configuration.client';
import { MemberClient } from './services/member-info.client';
import { ResortSummaryClientBase, ResortSummaryClient } from './services/resort-summary.client';
import { OvsMapComponent } from './shared/geo/ovs-map.component';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { ResortDetailClientBase, ResortDetailClient } from './services/resort-detail.client';
import { ResortOverviewComponent } from './resort-detail/resort-overview.component';
import { ResortAvailabilityComponent } from './resort-detail/resort-availability/resort-availability.component';
import { AvailabilityCarouselComponent } from './resort-detail/resort-availability/availability-carousel.component';
import { AvailabilityGalleryComponent } from './resort-detail/resort-availability/availability-gallery.component';
import { AvailabilityCardComponent } from './resort-detail/resort-availability/availability-card.component';
import { CheckoutComponent } from './check-out/check-out.component';
import { CheckOutHeaderComponent } from './check-out/checkout-header/checkout-header.component';
import { DestinationGalleryComponent } from './resort-detail/destination-gallery/destination-gallery.component';
import { ResortDestinationComponent } from './resort-detail/resort-destination.component';
import { OneColumnGalleryComponent } from './resort-detail/one-column-gallery/one-column-gallery.component';
import { ThreeColumnGalleryComponent } from './resort-detail/three-column-gallery/three-column-gallery.component';
import { ResortExtraComponent } from './resort-detail/resort-extra.component';
import { ResortSpaComponent } from './resort-detail/resort-spa.component';
import { ResortExploreComponent } from './resort-detail/resort-explore.component';
import { ResortFeaturesComponent } from './resort-detail/resort-features.component';
import { ModalDialogComponent } from './shared/modal-dialog.component';
import { StickyComponent } from './shared/sticky.component';
import { RoomAvailabilityComponent } from './resort-detail/room-availability/room-availability.component';
import { OvsResortAddressPipe } from './shared/resortAddress.pipe';
import { ResortInventoryClientBase, ResortInventoryClient } from './services/resort-inventory.client';
import { ResortStandardComponent } from './resort-standard/resort-standard.component';
import { ResortBookingClientBase, ResortBookingClient } from './services/resort-booking.client';
import { ConfirmationComponent } from './check-out/confirmation.component';
import { GuestComponent } from './check-out/guest/guest.component';
import { TermsComponent } from './check-out/terms.component';
import { Lingua, LinguaBase, LinguaOrdinalSuffixPipe } from './shared/core/ovs.lingua';
import { LoadingModule } from 'ngx-loading';
import { ResortMemberMessage } from './resort-detail/resort-member-message/resort-member-message.component';


import { CreditCardService } from './services/creditcard.service';
import { MemberService } from './services/member.service';
import { UpdateClientService } from './services/update-client.service';
import { InventoryDateRangeComponent } from './shared/inventory-date-range/inventory-date-range.component';
import { PricingInformationComponent } from './check-out/pricing-information/pricing-information.component';
import { ResortInformationComponent } from './check-out/resort-information/resort-information.component';

import { PercentBadgeComponent } from './shared/percent-badge/percent-badge.component';
import { PartnerHeaderComponent } from './header/partner-header/partner-header.component';
import { MktHeroComponent } from './hero/mkt-hero/mkt-hero.component';
import { MktHeroCarouselComponent } from './hero/mkt-hero-carousel/mkt-hero-carousel.component';
import { PSlideOneComponent } from './hero/mkt-slides/parallax-slides/plax-slide-one/plax-slide-one.component';
import { PSlideTwoComponent } from './hero/mkt-slides/parallax-slides/plax-slide-two/plax-slide-two.component';
import { PSlideThreeComponent } from './hero/mkt-slides/parallax-slides/plax-slide-three/plax-slide-three.component';
import { MktSlideComponent } from './hero/mkt-slides/mkt-slide/mkt-slide.component';
import { HeaderV2Component } from './header/header-v2/header-v2.component';
import { EarnRewardBadgeComponent } from './shared/earn-reward-badge/earn-reward-badge.component';
import { EarnRewardCardComponent } from './check-out/earn-reward-card/earn-reward-card.component';
import { ReadMoreComponent } from './shared/read-more/read-more.component';
import { RoomResultComponent } from './resort-detail/room-availability/room-result/room-result.component';
import { RoomResultEarnComponent } from './resort-detail/room-availability/room-result-earn/room-result-earn.component';

import { StorageService } from './services/storage-service.client';

import { AppInsightsModule, AppInsightsService } from 'microsoft-applicationinsights-angular5';
import { ResortInstrumentationModule, SearchEvents, ResortInsightsService } from './instrumentation/resort-instrumentation.module';
import { TealiumService } from './instrumentation/tealium/tealium.service';
import { environment } from '../environments/environment';
import { ResortListingHeaderComponent } from './resort-listing/resort-listing-header/resort-listing-header.component';
import { ModalConfirmComponent } from './shared/modal-confirm/modal-confirm.component';
import { ModalSearchFilterComponent } from './shared/modal-search-filter/modal-search-filter.component';
import { ModalMobileRoomDescriptionComponent } from './shared/modal-mobile-room-description/modal-mobile-room-description.component';
import { EnvironmentConfigurationService } from './services/environment-configuration.service';
import { EncoreService } from './services/encore.service';
import { OffsetSwiperComponent } from './shared/offset-swiper/offset-swiper.component';
import { BasicDialogComponent } from './shared/basic-dialog/basic-dialog.component';
import { BasicDialogService} from './shared/basic-dialog/basic-dialog.service';
import { RoomAvailabilityV2Component } from './room-availability/room-availability-v2/room-availability-v2.component';

import { ModalGalleryModule } from '@ks89/angular-modal-gallery';
import 'hammerjs';
import 'mousetrap';
import { RoomFilterMobileComponent } from './room-availability/room-filter-mobile/room-filter-mobile.component';
import { HeroCardComponent } from './room-availability/hero-card/hero-card.component';
import { RoomCardComponent } from './room-availability/room-card/room-card.component';
import { RoomGalleryComponent } from './room-availability/room-gallery/room-gallery.component';
import { BootstrapHelperService } from './instrumentation/bootstrap-helper.service';
import { ImageService } from './services/image.service';
import { NgbDateCustomParserFormatter } from './room-availability/room-filter-mobile/ngb-custom-date-formatter';
import { ResortCollageBannerComponent } from './shared/resort-collage-banner/resort-collage-banner.component';
import { DisplayOptionsService } from './services/display-options.service';
import { OceanUpgradeComponent } from './room-availability/ocean-upgrade/ocean-upgrade.component';
import { ContentApiClient } from './services/content-service';
import { DomainService } from './services/domain.service';
import { AlertComponent } from './shared/alert/alert.component';
import { CheckoutGuestsComponent } from './check-out/checkout-guests/checkout-guests.component';
import { GuestFormComponent } from './check-out/guest-form/guest-form.component';

//const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
//    direction: 'horizontal',
//    keyboard: true,
//    scrollbar: <SwiperScrollbarInterface>{ draggable: true, snapOnRelease: true },
//    loop: true,
//    navigation: <SwiperNavigationInterface>{ nextEl: '.main-swiper__btn--next', prevEl: '.main-swiper__btn--prev' },
//    autoplay: <SwiperAutoplayInterface>{ disableOnInteraction: false },
//    autoHeight: true
//};

@NgModule({
    declarations: [
        AppComponent,
        GeocoderResultDetailComponent,
        JoinPipe,
        OutlookChartComponent,
        MainHeaderComponent,
        MainFooterComponent,
        SearchCalendarComponent,
        ResortListingComponent,
        ResortListingPreferredComponent,
        ResortListingCarouselComponent,
        ResortListingStandardComponent,
        ResortDetailComponent,
        ResortHeroGalleryComponent,
        OvsMapComponent,
        OvsCurrencyPipe,
        ResortOverviewComponent,
        ResortAvailabilityComponent,
        AvailabilityCarouselComponent,
        AvailabilityGalleryComponent,
        CheckoutComponent,
        CheckOutHeaderComponent,
        DestinationGalleryComponent,
        ResortDestinationComponent,
        OneColumnGalleryComponent,
        ThreeColumnGalleryComponent,
        ResortExtraComponent,
        ResortSpaComponent,
        OvsResortAddressPipe,
        ResortExploreComponent,
        ResortFeaturesComponent,
        ModalDialogComponent,
        StickyComponent,
        RoomAvailabilityComponent,
        ResortStandardComponent,
        ConfirmationComponent,
        GuestComponent,
        LinguaOrdinalSuffixPipe,
        TermsComponent,
        AvailabilityCardComponent,
        CreditCardValidator,
        InventoryDateRangeComponent,
        PartnerHeaderComponent,
        PercentBadgeComponent,
        PricingInformationComponent,
        ResortInformationComponent,
        MktHeroComponent,
        MktHeroCarouselComponent,
        PSlideOneComponent,
        PSlideTwoComponent,
        PSlideThreeComponent,
        MktSlideComponent,
        HeaderV2Component,
        EarnRewardBadgeComponent,
        EarnRewardCardComponent,
        ReadMoreComponent,
        RoomResultComponent,
        RoomResultEarnComponent,
        ResortListingHeaderComponent,
        ModalConfirmComponent,
        ModalSearchFilterComponent,
        ModalMobileRoomDescriptionComponent,
        OffsetSwiperComponent,
        BasicDialogComponent,
        RoomAvailabilityV2Component,
        RoomFilterMobileComponent,
        HeroCardComponent,
        RoomCardComponent,
        RoomGalleryComponent,
        ResortCollageBannerComponent,
        OceanUpgradeComponent,
        ResortMemberMessage,
        AlertComponent,
        CheckoutGuestsComponent,
        GuestFormComponent
    ],
    entryComponents: [
        RoomAvailabilityComponent,
        TermsComponent,
        GuestComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        NgSelectModule,
        HttpModule,
        HttpClientModule,
        TruncateModule,
        NouisliderModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ParallaxMousemoveModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        NgxPageScrollModule,
        NgbModule.forRoot(),
        MatSliderModule,
        SwiperModule,
        MatDialogModule,
        LoadingModule,
        CookieModule.forRoot(),
        RouterModule.forRoot([
            { path: '', redirectTo: 'resort-listing', pathMatch: 'full'},
            { path: 'resort-listing', component: AppComponent},
            { path: 'search-resorts', component: ResortListingComponent, data: { state: 'listing'} },
            { path: 'resort-detail', component: ResortDetailComponent, data: { state: 'next' } },
            { path: 'resort-standard', component: ResortStandardComponent, data: { state: 'next' } },
            { path: 'check-out', component: CheckoutComponent, data: { state: 'checkout' } },
            { path: 'confirmation', component: ConfirmationComponent, data: { state: 'next' } },
            { path: '**', redirectTo: 'resort-listing' }
        ], { useHash: true }),
        ResortInstrumentationModule,
        ModalGalleryModule.forRoot(),
    ],
    providers: [
        { provide: Core, useClass: Core },
        { provide: DisplayServiceBase, useClass: DisplayService },
        { provide: ValidationServicesBase, useClass: ValidationServices },
        { provide: ResortApplicationBase, useClass: ResortApplication },
        { provide: UrlServiceBase, useClass: UrlService },
        { provide: QueryParamService, useClass: QueryParamService },
        { provide: ErrorHandler, useClass: DefaultErrorHandler },
        { provide: LinguaBase, useClass: Lingua },
        { provide: ApplicationConfigurationClientBase, useClass: ApplicationConfigurationClient },
        { provide: ResortSummaryClientBase, useClass: ResortSummaryClient },
        { provide: ResortDetailClientBase, useClass: ResortDetailClient },
        { provide: ResortInventoryClientBase, useClass: ResortInventoryClient },
        { provide: ResortBookingClientBase, useClass: ResortBookingClient },
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
        { provide: MemberClient, useClass: MemberClient },

        CreditCardService ,
        CookieService,
        UpdateClientService,
        StorageService,
        ResortInsightsService,
        TealiumService,
        EnvironmentConfigurationService,
        BasicDialogService,
        BootstrapHelperService,
        ImageService,
        DisplayOptionsService,
        ContentApiClient,
        DomainService
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/app.module.ts